// set function parseTime,formatTime to filter
export { parseTime, formatTime } from "@/utils";
import defaultImg from "@/assets/images/default.png";
function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}

/* 数字 格式化 */
export function numberFormatter(num, digits) {
  const si = [
    { value: 1e18, symbol: "E" },
    { value: 1e15, symbol: "P" },
    { value: 1e12, symbol: "T" },
    { value: 1e9, symbol: "G" },
    { value: 1e6, symbol: "M" },
    { value: 1e3, symbol: "k" }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}
// 转换金额格式
export function toMoneyFormat(num) {
  if (!num) {
    return "0.00";
  }
  return parseFloat(num).toFixed(2);
}
// 购物车商品状态 正常展示为空
export function toSkuStatusStr(num, noShowArr = []) {
  let skuStatus = [
    "无货",
    "有货",
    "下架",
    "不可售",
    "限购",
    "预订",
    "失效",
    "可售",
    "不限购",
    "",
    "单位限制"
  ];
  for (let i = 0; i < noShowArr.length; i++) {
    if (num === noShowArr[i]) {
      return "";
    }
  }
  return skuStatus[num];
}
// 购物车商品图片处理
export function goodsPicFormat(picUrl) {
  if (!picUrl) {
    return defaultImg;
  }
  return picUrl;
}
export function goodsPicFormatCar(picUrl) {
  if (!picUrl) {
    return defaultImg;
  }
  return formatImgUrl(picUrl);
}

export function formatImgUrl(url) {
  // 定义测试和生产环境的基URL
  const baseUrls = {
    test: "http://120.46.58.246/image-server",
    prod: "https://www.cvmc-easygo.com/image-server"
  };
  if (isProdEnv) {
    return baseUrls.prod + url;
  } else {
    return baseUrls.test + url;
  }
}

export function isProdEnv() {
  const o = window.location;
  let arr = o.hostname.split("-");
  if (arr.length === 1) {
    return true;
  } else {
    if (o.hostname.includes("uat01-")) {
      return false;
    } else {
      return false;
    }
  }
}

// 判断商品是否可加入购物车
export function isdisabled(index) {
  // let skuStatus = ["无货", "有货", "下架", "商品不可售", "限购", "预订", "失效", "可售", "不限购"];
  if (index === 1 || index === 5 || index === 7 || index === 8) {
    return false;
  }
  return true;
}

// export function formatNumber(num) {
//   if (num === null || num === undefined) {
//     return "";
//   }
//   const parts = Number(num)
//     .toFixed(2)
//     .toString()
//     .split(".");
//   parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
//   return parts.join(".");
// }
